import type { FieldConfig, FieldValue, FieldValues } from '../types/models';

const isEmpty = (v: FieldValue): boolean =>
  Array.isArray(v) ? v.length === 0 : v === undefined || v === null || v === '';

/**
 * Required, currently-editable, non-calculated fields whose value is empty.
 * Callers must pass only the configs they actually render to the user (not the
 * full catalog) - a field marked required but rendered through bespoke markup,
 * or excluded from this page's cards entirely, has no visible spot for the user
 * to fix it, so it must not be included in this check.
 */
export function getMissingRequiredFields(configs: FieldConfig[], values: FieldValues): string[] {
  return configs
    .filter((c) => c.isRequired && c.isEditable && !c.isCalculated)
    .filter((c) => isEmpty(values[c.fieldId]))
    .map((c) => c.fieldId);
}
